import { render, staticRenderFns } from "./StaRecord.vue?vue&type=template&id=801c4e42&scoped=true&"
import script from "./StaRecord.vue?vue&type=script&lang=js&"
export * from "./StaRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801c4e42",
  null
  
)

export default component.exports